define([
	"csi/access/_base",
	"csi/access/access",
	"csi/access/full",
], function(csiAccess, access, full) {
	var productSpecAdminRoles = ['Product Specification Administrator'];
	var productSpecLibAdminRoles = ['Product Specification Library Administrator'];
	var tdsSpecAdminRoles = ['TDS - Spec Administrator'];

	csiAccess.addViewRoles({
        "_CS_Data": {
			"SpecificationDataSheetTemplates": {
                "Copy": access(full(productSpecAdminRoles), full(tdsSpecAdminRoles)),
                "NewDataSheetTemplates": access(full(productSpecAdminRoles), full(tdsSpecAdminRoles))
            },
            "SpecificationItemDefinitions": {
                "Copy":access(full(productSpecLibAdminRoles)),
                "NewSpecificationItemDefinition":access(full(productSpecLibAdminRoles))
            },
            "SpecificationSectionDefinitions": {
                "Copy":access(full(productSpecLibAdminRoles)),
                "NewSpecificationSectionDefinition":access(full(productSpecLibAdminRoles))
            }
        }
    });
});